import { memo } from 'react';
import { useParams } from 'react-router';
import { GoodTypeEnum } from '../../pages/MarketStudiesResultPage';

import { nanoid } from '@reduxjs/toolkit';
import { statTypeFieldValues } from './constant';
import Good from './Good';

interface IGoodTypeContainerProps {
  type: GoodTypeEnum;
}

const GoodContainer = ({ type }: IGoodTypeContainerProps) => {
  const { id } = useParams();

  const goodStatPerRoomLoop = (idProps: string) => {
    const tabToDisplay: React.ReactNode[] = [];

    for (let i = 1; i <= 6; i += 1) {
      tabToDisplay.push(
        <Good
          key={nanoid()}
          goodType={GoodTypeEnum.CONSTRUCTION}
          partialLabel={i.toString()}
          id={idProps}
        />,
      );
    }

    return <>{tabToDisplay}</>;
  };

  const goodStatPerGroundLoop = (idProps: string) => {
    const tabToDisplay: React.ReactNode[] = [];

    statTypeFieldValues.forEach((e) => {
      tabToDisplay.push(
        <Good
          key={nanoid()}
          goodType={GoodTypeEnum.TERRAIN}
          partialLabel={e}
          id={idProps}
        />,
      );
    });

    return <>{tabToDisplay}</>;
  };

  if (id) {
    if (type === GoodTypeEnum.TERRAIN) {
      return goodStatPerGroundLoop(id);
    } else {
      return goodStatPerRoomLoop(id);
    }
  } else {
    return null;
  }
};

export default memo(GoodContainer);
